import { useUserProps } from '../UserPropsContext';
import ImpersonationActivated from '../../../user/Settings/ImpersonateUser/ImpersonationActivated';
import NavbarBrandLogos from './microComponents/NavbarBrandLogos';
import NavbarItems from './microComponents/NavbarItems';
import styles from './Navbar.module.scss';
import { clsx } from 'clsx';
import { useTenantStore } from '../../../../stores/tenantStore';

const ImpersonationBanner = () => {
  const { isImpersonationModeOn } = useUserProps();
  if (!isImpersonationModeOn) return null;
  return (
    <div className={styles.impersonationBanner}>
      <ImpersonationActivated />
    </div>
  );
};

const MainNavigationHeader = () => {
  const { isImpersonationModeOn } = useUserProps();

  const headerStyles = clsx(styles.mainNavigationHeader, {
    [styles.impersonationMode]: isImpersonationModeOn,
  });
  return (
    <header className={headerStyles}>
      <NavbarBrandLogos />
      <NavbarItems />
    </header>
  );
};

export default function Navbar() {
  const isInitialized = useTenantStore((state) => state.isInitialized);
  const { setUser, logoutUser, auth0Error } = useUserProps();

  if (!isInitialized) return null;

  if (auth0Error) {
    const { message } = auth0Error;

    // TODO: Remove '401' case after July 31, 2026. Confirm whether safe to remove before then.
    if (message === '401' || message === 'email_not_verified') {
      if (typeof window !== 'undefined') {
        setUser(null);
        logoutUser(`${window.location.origin}/verify-email`);
      }
    } else if (message === 'Invalid state') {
      setUser(null);
    } else if (typeof window !== 'undefined') {
      if (message) {
        alert(message);
      }
      setUser(null);
      logoutUser(`${window.location.origin}/`);
    }
  }

  return (
    <div className={styles.navbar}>
      <ImpersonationBanner />
      <MainNavigationHeader />
    </div>
  );
}
